export const menuConst = {
  M001: 'M001',
  M002: 'M002',
  M003: 'M003',
  M004: 'M004',
  M005: 'M005',
  M006: 'M006'
}